import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	noCategory: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noCategory: {
		id: 'issue-table-grouping.group-row.group-header.category-group-header.no-category',
		defaultMessage: 'Uncategorized',
		description: 'Label for grouped items without category',
	},
});
export default messages;
